import { useMediaQuery } from "@mui/material";
import React from "react";
import HeaderMobile from "./HeaderMobile";
import HeaderDesktop from "./HeaderDesktop";

const Header = ({
  headerData,
  HeaderDimensions,
  pageWidthCalc,
  headerPosition,
  sectionPositions,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <>
      {isMobile ? (
        <HeaderMobile
          HeaderDimensions={HeaderDimensions}
          sectionPositions={sectionPositions}
        />
      ) : (
        <HeaderDesktop
          headerData={headerData}
          HeaderDimensions={HeaderDimensions}
          pageWidthCalc={pageWidthCalc}
          headerPosition={headerPosition}
          sectionPositions={sectionPositions}
        />
      )}
    </>
  );
};

export default Header;
